
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { LOGO_URL } from '../constants';

interface HeaderProps {
  onApplyClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onApplyClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Vision', href: '#vision' },
    { name: 'Curriculum', href: '#curriculum' },
    { name: 'Recruitment', href: '#recruitment' },
    { name: 'FAQ', href: '#faq' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img 
            src={LOGO_URL} 
            alt="ENACTUS Logo" 
            className="h-8 w-auto" 
          />
          <span className="font-bold text-xl tracking-tighter">ENACTUS YM</span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              className="text-sm font-medium hover:text-[#FFC222] transition-colors"
            >
              {link.name}
            </a>
          ))}
          <button 
            onClick={onApplyClick}
            className="bg-[#FFC222] text-black px-5 py-2 rounded-full text-sm font-bold hover:scale-105 transition-transform"
          >
            17기 지원하기
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-white"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Nav Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 top-[72px] bg-black z-40 flex flex-col items-center justify-center gap-8 p-6 md:hidden">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              className="text-2xl font-bold"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <button 
            onClick={() => {
              onApplyClick();
              setIsMobileMenuOpen(false);
            }}
            className="bg-[#FFC222] text-black px-8 py-3 rounded-full text-lg font-bold w-full max-w-xs"
          >
            17기 지원하기
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
